import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    textAlign: 'right',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
}))

export default function FooterBar() {
  const classes = useStyles()

  return (
    <div className={ classes.grow }>

      <AppBar position="static">
        <Box p={ 1 }>
          <Typography className={ classes.title } variant="span" noWrap>
            <Link
              color="inherit"
              target="_blank"
              href="//www.ecostage.com.br"
            >
              Desenvolvido por Ecostage
            </Link>
          </Typography>
        </Box>
      </AppBar>
    </div>
  )
}
